export const validateQuantityOneToOneHundred = (
  value: any,
  formData: any,
  name: any,
) => {
  const isValid = value <= 100
  return value && !isValid && 'Must be 1-100'
}
